export const TEMPLATE_LABELS: Record<string, string> = {
  STANDARD: 'Standard Template',
  NEUTRAL: 'Neutral Template'
};

export const MAIL_SENDER_LABELS: Record<string, string> = {
  FLOW: '7i7® flow',
  COMPANY: '7i7® Design GmbH'
};
